import { getIpPrefix } from '@micromart/kiosk-app-shared/lib/ip'

export const getLocalIpAddress = () => {
	return '192.168.1.227'
}

export const getLocalIpPrefix = () => {
	const ipAddress = getLocalIpAddress()
	const ipPrefix = getIpPrefix(ipAddress)
	return ipPrefix
}
